import React from 'react';

interface SpotPrice {
	month_year: string;
	month_label: string;
	cee_classique: number | null;
	cee_precarite: number | null;
}

interface CeeSpotTableProps {
	data: SpotPrice[];
}

const formatPrice = (price: number | null): string => {
	if (price === null) return '-';
	return price.toFixed(2).replace('.', ',');
};

const ChartIcon: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<line x1="18" y1="20" x2="18" y2="10"></line>
		<line x1="12" y1="20" x2="12" y2="4"></line>
		<line x1="6" y1="20" x2="6" y2="14"></line>
	</svg>
);

interface PriceDisplayProps {
	price: number | null;
	type: 'classique' | 'precarite';
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({ price, type }) => {
	if (price === null) {
		return (
			<span className="gext-cee-spot-table__price gext-cee-spot-table__price--empty">
				-
			</span>
		);
	}
	return (
		<span
			className={`gext-cee-spot-table__price gext-cee-spot-table__price--${type}`}
		>
			{formatPrice(price)}
		</span>
	);
};

const CeeSpotTable: React.FC<CeeSpotTableProps> = ({ data }) => {
	if (!data || data.length === 0) {
		return (
			<div className="gext-cee-spot-table gext-cee-spot-table--empty">
				<p>Aucune donnée disponible</p>
			</div>
		);
	}

	return (
		<div className="gext-cee-spot-table">
			<div className="gext-cee-spot-table__card">
				<div className="gext-cee-spot-table__header">
					<div className="gext-cee-spot-table__header-icon">
						<ChartIcon />
					</div>
					<div className="gext-cee-spot-table__header-content">
						<h3 className="gext-cee-spot-table__title">Prix CEE au comptant</h3>
						<p className="gext-cee-spot-table__description">
							Moyenne des prix de clôture des Certificats d'Économie d'Énergie (SPOT)
						</p>
					</div>
				</div>
				<table className="gext-cee-spot-table__table">
					<thead>
						<tr>
							<th>Mois</th>
							<th>
								CEE Classique
								<span className="gext-cee-spot-table__unit">€/MWhc</span>
							</th>
							<th>
								CEE Précarité
								<span className="gext-cee-spot-table__unit">€/MWhc</span>
							</th>
						</tr>
					</thead>
					<tbody>
						{data.map((row, index) => (
							<tr key={index}>
								<td>{row.month_label}</td>
								<td>
									<PriceDisplay price={row.cee_classique} type="classique" />
								</td>
								<td>
									<PriceDisplay price={row.cee_precarite} type="precarite" />
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<div className="gext-cee-spot-table__footer">
					<ul className="gext-cee-spot-table__legend">
						<li className="gext-cee-spot-table__legend-item">
							<span className="gext-cee-spot-table__legend-dot gext-cee-spot-table__legend-dot--classique"></span>
							Classique
						</li>
						<li className="gext-cee-spot-table__legend-item">
							<span className="gext-cee-spot-table__legend-dot gext-cee-spot-table__legend-dot--precarite"></span>
							Précarité
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default CeeSpotTable;
